import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import "./App.css";

import Nav from "./componentes/navbar/navbar";
import Footer from "./componentes/footer/footer";
import Loader from "./componentes/loader/loader";
import PortafolioView from "./routes/portafolioView/PortafolioView";
import Home from "./routes/home/Home";
import Tyr from "./routes/tyr/Tyr";
import Links from "./routes/links/Links";
import NoticiasView from "./routes/noticiasView/noticiasView";
import Redes from "./componentes/redes/Redes";
import Chatbot from "./componentes/chatbot/Chatbot";
import NoRouteView from "./routes/noRouteView/noRouteView";
import Login from "./routes/login/login";
import ContextNoticias from "./servicios/context";
import AnimationProvider from "./componentes/animation/AnimationProvider";

function App() {
  const [loader, setLoader] = useState(true);

  return loader ? (
    <ContextNoticias>
      <Loader setLoader={setLoader} />
    </ContextNoticias>
  ) : (
    <AnimationProvider>
      <BrowserRouter>
        <ContextNoticias>
          <div className="App">
            <section id="navbar">
              <Nav />
            </section>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/sobre-mi" element={<PortafolioView />} />
              <Route path="/tyr" element={<Tyr />} />
              <Route
                path="/freelance"
                element={<Navigate to="/tyr" replace />}
              />
              <Route path="/links" element={<Links />} />
              <Route path="/noticias" element={<NoticiasView />} />
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<NoRouteView />} />
            </Routes>
            <Redes />
            <section id="footer">
              <Footer />
            </section>
            <Chatbot />
          </div>
        </ContextNoticias>
      </BrowserRouter>
    </AnimationProvider>
  );
}

export default App;
